import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { DataSubscriptionService } from './../../../shared/services/data-subscription.service';
import { REPORTING_EVENTS } from './../../services/reporting.service';

@Component({
  selector: 'ab-report-table',
  templateUrl: './report-table.component.html',
  styleUrls: ['./report-table.component.scss']
})
export class ReportTableComponent implements OnDestroy {
  public columns: Array<string>;
  public totalNumberOfRecordsAvailable: number;
  public items: Array<any> = [];
  public dataSubscription: Subscription;
  public show: boolean;
  public isLoading: boolean;
  public title: string;
  public hasMore: boolean;

  constructor(private dataSubscriptionService: DataSubscriptionService) {}

  subscribe(type: string): void {
    this.dataSubscription = this.dataSubscriptionService
      .getData()
      .subscribe(data => {
        switch (data.event) {
          case type:
            this.show = true;
            this.hasMore = data.data.hasMore;

            if (data.data.hasMore || data.data.afterSubmit) {
              this.title = data.data.title;
              this.totalNumberOfRecordsAvailable =
                data.data.totalNumberOfRecordsAvailable;
              this.items =
                data.data.page === 0
                  ? data.data.items
                  : this.items.concat(data.data.items);
            }
            break;
          case REPORTING_EVENTS.SCROLLING:
            this.isLoading = true;
            break;
          case REPORTING_EVENTS.STOP_LOADING:
            this.isLoading = false;
            break;
          default:
            this.show = false;
            break;
        }
      });
  }

  ngOnDestroy() {
    this.dataSubscription.unsubscribe();
  }

  onScroll() {
    if (!this.isLoading) {
      this.isLoading = true;
      this.dataSubscriptionService.onScroll();
    }
  }
}
